import {
  enumOutboxEventStatus,
  OutboxEventStatus,
} from '@rematter/frontend-lib-api-client';
import {
  ChatMessageRole,
  ChatStatus,
} from '@rematter/frontend-lib-api-client/grpc/assistant/v1/assistant_pb';
import { ThemeColor } from '@rematter/ui-web';

export const chatStatusColors: Record<ChatStatus, ThemeColor> = {
  [ChatStatus.ACTIVE]: 'success',
  [ChatStatus.ARCHIVED]: 'neutral',
  [ChatStatus.UNSPECIFIED]: 'neutral',
};

export const chatMessageRoleColors: Record<ChatMessageRole, ThemeColor> = {
  [ChatMessageRole.USER]: 'primary',
  [ChatMessageRole.ASSISTANT]: 'teal',
  [ChatMessageRole.SYSTEM]: 'neutral',
  [ChatMessageRole.UNSPECIFIED]: 'neutral',
};

export const outboxEventStatusColor: Record<OutboxEventStatus, ThemeColor> = {
  [enumOutboxEventStatus.DeadLetter]: 'failure',
  [enumOutboxEventStatus.Failed]: 'failure',
  [enumOutboxEventStatus.Pending]: 'warning',
  [enumOutboxEventStatus.Processed]: 'success',
};
